<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Swal from 'sweetalert2'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'

import { required, requiredIf } from 'vuelidate/lib/validators'

import { VEHICLE_MUTATION_CREATE, VEHICLE_MUTATION_UPDATE } from '@/services/api/master/fleet'
import { GET_VEHICLE_TYPE } from '@/services/api/setting/fleet/fleetType'
import { GET_MODEL } from '@/services/api/setting/fleet/fleetModel'
import { GET_BOX } from '@/services/api/setting/fleet/boxType'
import { GET_THERMO } from '@/services/api/setting/fleet/thermoType'
import { GET_DRIVERS } from '@/services/api/master/drivers'
import { GET_DEVICES } from '@/services/api/master/tracking'
import { GET_GEOFENCES } from '@/services/api/master/geofence'
import { GET_VEHICLE_ID } from '@/services/api/master/fleet'

moment.locale('id')
/**
 * Starter component
 */
export default {
  page: {
    title: 'Form Kendaraan',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  mixins: [Helper],
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  apollo: {
    vehicleModels: {
      query: GET_MODEL,
    },
    vehicleTypes: {
      query: GET_VEHICLE_TYPE,
      variables() {
        return {
          filter: {
            isActive: true,
          },
        }
      },
    },
    thermoTypes: {
      query: GET_THERMO,
    },
    boxTypes: {
      query: GET_BOX,
    },
    drivers: {
      query: GET_DRIVERS,
      variables() {
        return {
            filter:{
              disablePagination:true,
              filter:{
                isAvailableOnly:true
              }
            }
        }
      },
    },
    devices: {
      query: GET_DEVICES,
      variables() {
        return {
          filter: {
            hasRelation: false,
          },
        }
      },
    },
    geofences: {
      query: GET_GEOFENCES,
      variables() {
        return {
          filter: {
            isGarage: true,
          },
        }
      },
    },
    vehicle: {
      query: GET_VEHICLE_ID,
      variables() {
        return {
          filter: {
            id: parseInt(this.$route.params.id),
          },
        }
      },
      // Disable the query
      skip() {
        return !this.$route.params.id
      },
      result({ data, loading }) {
        if (!loading) {
          if (!data.vehicle.isSuccessful) {
            this.$toast.warning(data.vehicle.message)
          }
          this.initEditPage(data.vehicle.vehicle)
        }
      },
    },
  },
  data() {
    return {
      selected: [],
      selectedModel: [],
      allSelected: false,
      indeterminate: true,
      selectedFleet: null,
      tData: [],

      formOld: {},
      form: {
        licensePlate: null,
        fleetType: null,
        status: {
          key: 'I',
          label: this.$t('master.form.fleet.status.active'),
        },
        device: null,
        hullNo: null,
        chassisNumber: null,
        machineNumber: null,
        boxType: null,
        thermoType: null,
        model: null,
        year: null,
        odometer: 0,
        carrosserie: null,
        firstDriver: {
          userId: null,
          isDriver: null,
          fullname: null,
        },
        fuelEfficiency: 0,
        geofence: null,
        ownership: null,
      },
      oldInput:{
        odometer:0
      },

      statusOptions: [
        {
          key: 'I',
          label: this.$t('master.form.fleet.status.active'),
        },
        {
          key: 'R',
          label: this.$t('master.form.fleet.status.repair'),
        },
        {
          key: 'A',
          label: this.$t('master.form.fleet.status.archive'),
        },
      ],

      vehicleModels: {
        vehicleModels: [],
      },

      vehicleTypes: {
        vehicleTypes: [],
      },

      thermoTypes: {
        thermoTypes: [],
      },

      boxTypes: {
        boxTypes: [],
      },

      drivers: {
        drivers: [],
      },

      devices: {
        devices: [],
      },

      geofences: {
        geofences: {
          data: []
        },
      },

      vehTypeOptions: [],
      docTypeOptions: [
        'STNK',
        'BPKB',
        'KIR Head',
        'KIR Chassis',
        'Pajak Tahunan',
        'STID',
        'KP',
        'SIPA',
        'SKPD',
        'Uji Emisi',
        'B3',
        'KLHK',
        'Kemenhub',
      ],

      vehicleOwnerships: [
        {
          key: 'O',
          label: 'Own Transport',
        },
        {
          key: 'V',
          label: 'Vendor Transport',
        },
        {
          key: 'C',
          label: 'On-Call Transport',
        },
      ],

      loading: false,
    }
  },
  validations: {
    form: {
      licensePlate: { required },
      fleetType: { required },
      model: { required },
      odometer: { },
      ownership: { required },
    },
    tData: {
      $each: {
        docType: {
          required: requiredIf(function () {
            return this.tData !== undefined && this.tData.length > 0
          }),
        },
      },
    },
  },
  computed: {
    fields() {
      return [
        {
          key: 'check',
        },
        {
          key: 'type',
          label: 'Nama Dokumen',
          tdClass: 'mc-table--50',
        },
        {
          key: 'number',
          label: 'Nomor Dokumen',
          tdClass: 'mc-table--50',
        },
        {
          key: 'expired',
          label: 'Tanggal Akhir Berlaku',
        },
        {
          key: 'status',
          label: 'Status',
        },
      ]
    },
    title() {
      return this.$route.params.id === undefined ? this.$t('master.form.fleet.newVehicle') : this.$t('master.form.fleet.updateVehicle')
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
        },
        {
          text: this.$t('menuitems.masterData.list.fleet'),
        },
        {
          text: this.$route.params.id === undefined ? this.$t('master.form.fleet.newVehicle') : this.form.licensePlate,
        },
      ]
    },
    firstDriverOptions() {
      if(this.drivers.drivers.data == undefined) return []
      if (this.form.firstDriver != null) {
        return this.drivers.drivers.data.filter(
          (item) => item.userId != this.form.firstDriver.userId
        )
      }
      return this.drivers.drivers.data
    },

    yearShow() {
      var year = this.form.year
      if (year !== null) {
        var now = moment().format('YYYY-01-01')
        var pick = moment(year).format('YYYY-01-01')
        var diff = moment(now).diff(pick, 'years')

        return year + ` (${diff})`
      }
      return null
    },

    docTypeUnSelected() {
      var selectedDoc = this.tData.map((item) => item.docType)
      selectedDoc = selectedDoc.filter((item) => item != null)

      var options = this.docTypeOptions.filter((item) => {
        return !selectedDoc.includes(item)
      })

      return options
    },
  },
  mounted() {
    this.$apollo.queries.vehicle.refetch()
    this.$apollo.queries.drivers.refetch()
    this.$apollo.queries.devices.refetch()

    for (let i = 0; i < this.tData.length; i++) {
      this.selectedModel.push(false)
    }
  },
  watch: {
   'form.odometer':function(newValue,oldValue){
        if(newValue==oldValue){
          return
        }
        if(newValue==""){
          return 
        }
        let val

        if(oldValue.toString()=="0"&&(newValue.length>1&&(newValue[1]==","||newValue[1]=="."))){
          val = newValue.substring(1)
        }else{
          val = newValue
        }

        const REG = /^((?!0)\d{1,16}|0|[.,]\d{1,2})($|[.,]$|[.,]\d{1,2}$)/gm
        let regexTest = REG.test(val)
        if(!regexTest){
          this.$nextTick(()=>{
            this.form.odometer = oldValue
          })
        }else{
          if(oldValue=="0"){
            this.$nextTick(()=>{
              this.form.odometer = val
              this.oldInput.odometer = val
            })
          }
        }
        return  regexTest
   },
    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length == this.tData.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    },
  },
  methods: {
    initEditPage(item) {
      this.tData.splice(0, this.tData.length)
      let statusLabel = ''
      if (item.status === 'I') {
        statusLabel = this.$t('master.form.fleet.status.active')
      } else if (item.status === 'R') {
        statusLabel = this.$t('master.form.fleet.status.repair')
      } else if (item.status === 'A') {
        statusLabel = this.$t('master.form.fleet.status.archive')
      }

      let ownershipLabel = ''
      if (item.ownership === 'O') {
        ownershipLabel = 'Own Transport'
      } else if (item.ownership === 'V') {
        ownershipLabel = 'Vendor Transport'
      } else if (item.ownership === 'C') {
        ownershipLabel = 'On-Call Transport'
      }

      this.form.model = {
        model: `${item.vehicleType.manufacturer} - ${item.vehicleType.model}`,
      }
      this.chooseVehType()

      this.form = {
        licensePlate: item.licensePlate,
        model: {
          model: `${item.vehicleType.manufacturer} - ${item.vehicleType.model}`,
        },
        fleetType: item.vehicleType,
        status: {
          key: item.status,
          label: statusLabel,
        },
        device: item.device ? item.device : null,
        hullNo: item.hullNo,
        chassisNumber: item.chassisNumber,
        machineNumber: item.machineNumber,
        boxType: item.boxType === null ? item.boxType : { text: item.boxType },
        thermoType: item.thermoType === null ? item.thermoType : { text: item.thermoType },
        year: item.year ? item.year.toString() : null,
        odometer: item.odometer,
        carrosserie: item.carrosserie,
        firstDriver: item.driver1
          ? {
              userId: item.driver1 ? item.driver1.userId : null,
              isDriver: item.driver1 ? item.driver1.isDriver : null,
              fullname: item.driver1 ? item.driver1.fullname : null,
            }
          : {
            userId: null,
            isDriver: null,
            fullname: null,
          },
        fuelEfficiency: item.fuelEfficiency,
        geofence: item.garage,
        ownership: item.ownership 
          ? {
              key: item.ownership,
              label: ownershipLabel,
            }
          : null,
      }

      let vehicleDocs = []
      item.vehicleDocs.forEach((row, index) => {
        this.tData.push({
          docType: row.docType,
          docNumber: row.docNumber || null,
          validUntil: row.validUntil ? this.momentYmD(row.validUntil) : null,
        })

        vehicleDocs.push({
          docType: row.docType,
          docNumber: row.docNumber || null,
          validUntil: row.validUntil || null,
        })

        this.checkStatus(index)
      })

      this.formOld = {
        licensePlate: item.licensePlate,
        model: {
          model: `${item.vehicleType.manufacturer} - ${item.vehicleType.model}`,
        },
        fleetType: item.vehicleType,
        status: {
          key: item.status,
          label: statusLabel,
        },
        device: item.device ? item.device : null,
        hullNo: item.hullNo,
        chassisNumber: item.chassisNumber,
        machineNumber: item.machineNumber,
        boxType: { text: item.boxType },
        thermoType: { text: item.thermoType },
        year: item.year ? item.year.toString() : null,
        odometer: item.odometer,
        carrosserie: item.carrosserie,
        firstDriver: item.driver1
          ? {
              userId: item.driver1 ? item.driver1.userId : null,
              isDriver: item.driver1 ? item.driver1.isDriver : null,
              fullname: item.driver1 ? item.driver1.fullname : null,
            }
          : {
            userId: null,
            isDriver: null,
            fullname: null,
          },
        fuelEfficiency: item.fuelEfficiency,
        geofence: item.garage,
        vehicleDocs: vehicleDocs,
        ownership: item.ownership 
          ? {
              key: item.ownership,
              label: ownershipLabel,
            }
          : null,
      }
    },
    chooseVehType() {
      this.$v.form.fleetType.$model = null
      const model = this.form.model.model.split(' - ')
      const vehType = this.vehicleTypes.vehicleTypes.filter(function (row) {
        return row.manufacturer == model[0] && row.model == model[1]
      })

      const groupByCategory = vehType.reduce((group, row) => {
        const { category } = row
        group[category] = group[category] ?? []
        group[category].push(row)
        return group
      }, {})

      this.vehTypeOptions.splice(0, this.vehTypeOptions.length)
      for (const [key, value] of Object.entries(groupByCategory)) {
        this.vehTypeOptions.push({
          parent: key != 'null' ? key : 'Tidak Memiliki Kategori',
          libs: value,
        })
      }
    },
    toggleAll(checked) {
      this.selectedModel = []
      this.selected = []
      if (checked) {
        for (let i = 0; i < this.tData.length; i++) {
          this.selected.push(i)
          this.selectedModel.push(true)
        }
      } else {
        for (let i = 0; i < this.tData.length; i++) {
          this.selectedModel.push(false)
        }
        this.selected = []
      }
    },
    checkTable(event, data) {
      if (event) {
        this.selected.push(data.index)
      } else {
        var myIndex = this.selected.indexOf(data.index)
        if (myIndex !== -1) {
          this.selected.splice(myIndex, 1)
        }
      }
    },
    checkStatus(index) {
      const today = new Date()
      const zeroPad = (num, places) => String(num).padStart(places, '0')
      const date =
        today.getFullYear() +
        '-' +
        zeroPad(today.getMonth() + 1, 2) +
        '-' +
        zeroPad(today.getDate(), 2)

      if (date > this.tData[index].validUntil) {
        this.tData[index].status = 'expired'
      } else {
        const range = this.getDatesInRange(date, this.tData[index].validUntil).length
        if (range <= 30) {
          this.tData[index].status = 'near'
        } else {
          this.tData[index].status = 'active'
        }
      }
    },
    addDocumentPermit() {
      this.tData.push({
        docType: null,
        docNumber: null,
        validUntil: null,
        status: null,
      })
    },
    toDelete() {
      this.selected.sort()
      this.selected.reverse()
      this.selected.forEach((row) => {
        this.$delete(this.tData, row)
      })
      this.selected = []
      this.selectedModel = []

      this.indeterminate = false
      this.allSelected = false
      for (let i = 0; i < this.tData.length; i++) {
        this.selectedModel.push(false)
      }
    },
    checkEmpty() {
      var isEmpty = true
      var forms = this.form
      var excepts = ['odometer', 'fuelEfficiency', 'status']
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != null && forms[key] != '') {
          if (typeof forms[key] !== 'object') {
            if (!excepts.includes(key)) {
              isEmpty = false
            }
          } else {
            if (!excepts.includes(key)) {
              Object.keys(forms[key]).forEach(function (subKey) {
                if (forms[key][subKey] != null && forms[key][subKey] != '') {
                  isEmpty = false
                }
              })
            }
          }
        }
      })

      return isEmpty
    },

    checkChanged() {
      var isChanged = false
      var forms = this.form
      var formOld = this.formOld
      Object.keys(this.form).forEach(function (key) {
        if (forms[key] != formOld[key]) {
          if (key == 'model' && forms[key] != null) {
            if (forms[key].model != formOld[key].model) {
              isChanged = true
            }
          } else if (key == 'status' && forms[key] != null) {
            if (forms[key].key != formOld[key].key) {
              isChanged = true
            }
          } else if (key == 'boxType' && forms[key] != null) {
            if (forms[key].text != formOld[key].text) {
              isChanged = true
            }
          } else if (key == 'thermoType' && forms[key] != null) {
            if (forms[key].text != formOld[key].text) {
              isChanged = true
            }
          } else if (key == 'firstDriver' && forms[key] != null) {
            if (forms[key].userId != formOld[key].userId) {
              isChanged = true
            }
          } else if (key == 'device' && forms[key] != null) {
            if (forms[key].imei != formOld[key].imei) {
              isChanged = true
            }
          } else if (key == 'ownership' && forms[key] != null) {
            if (forms[key].key != formOld[key].key) {
              isChanged = true
            }
          } else {
            isChanged = true
          }
        }
      })

      return isChanged
    },

    toCancel() {
      var isEmpty = this.checkEmpty()
      if (this.$route.params.id) {
        isEmpty = !this.checkChanged()
      }

      if (isEmpty) {
        this.$router.push('/master/fleet')
      } else {
        Swal.fire({
          title: 'Batalkan',
          text: 'Anda yakin akan membatalkan',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#f46a6a',
          cancelButtonColor: '#34c38f',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        }).then((result) => {
          if (result.value) {
            this.$router.push('/master/fleet')
          }
        })
      }
    },
    handleOk() {
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      let vehicleDocs = []
      this.tData.forEach((row) => {
        vehicleDocs.push({
          docType: row.docType,
          docNumber: row.docNumber || null,
          validUntil: row.validUntil || null,
        })
      })

      let input = {
        vehicleDocs: vehicleDocs,
        driver1Id: this.form.firstDriver ? this.form.firstDriver.userId : null,
        garageId: this.form.geofence ? this.form.geofence.geofenceId : null,
        fuelEfficiency: this.form.fuelEfficiency ? parseFloat(this.form.fuelEfficiency) : 0,
        odometer: this.form.odometer ? parseFloat(this.form.odometer.toString().includes(',')?this.form.odometer.toString().replace(',','.'):this.form.odometer) : 0,
        status: this.form.status.key,
        imei: this.form.device ? this.form.device.imei : null,
        licensePlate: this.$v.form.licensePlate.$model.toUpperCase(),
        vehicleTypeId: this.$v.form.fleetType.$model.vehicleTypeId,
        thermoType: this.form.thermoType ? this.form.thermoType.text : null,
        boxType: this.form.boxType ? this.form.boxType.text : null,
        hullNo: this.form.hullNo,
        chassisNumber: this.form.chassisNumber,
        machineNumber: this.form.machineNumber,
        carrosserie: this.form.carrosserie ? this.form.carrosserie : '',
        year: parseInt(this.form.year),
        ownership: this.form.ownership.key,
      }

      if (!this.$route.params.id) {
        this.$apollo
          .mutate({
            mutation: VEHICLE_MUTATION_CREATE,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response.data.createVehicle.isSuccessful) {
              this.$toast.success(`Data berhasil tersimpan`)
              this.$router.push({ name: 'Master Fleet' })
            } else {
              this.$toast.error(response.data.createVehicle.message)
            }
          })
      } else {
        let inputOld = {
          driver1Id: this.formOld.firstDriver ? this.formOld.firstDriver.userId : null,
          garageId: this.formOld.geofence ? this.formOld.geofence.geofenceId : null,
          fuelEfficiency: parseFloat(this.formOld.fuelEfficiency),
          odometer: parseFloat(this.formOld.odometer),
          status: this.formOld.status ? this.formOld.status.key : null,
          imei: this.formOld.device ? this.formOld.device.imei : null,
          licensePlate: this.formOld.licensePlate,
          vehicleTypeId: this.formOld.fleetType.vehicleTypeId,
          thermoType: this.formOld.thermoType ? this.formOld.thermoType.text : null,
          boxType: this.formOld.boxType ? this.formOld.boxType.text : null,
          hullNo: this.formOld.hullNo,
          chassisNumber: this.formOld.chassisNumber,
          machineNumber: this.formOld.machineNumber,
          carrosserie: this.formOld.carrosserie,
          year: parseInt(this.formOld.year),
          vehicleDocs: this.formOld.vehicleDocs,
          ownership: this.formOld.ownership ? this.formOld.ownership.key : null,
        }

        input = { ...input, vehicleId: this.form.vehicleId }
        this.$apollo
          .mutate({
            mutation: VEHICLE_MUTATION_UPDATE,
            variables: {
              input: {
                id: parseInt(this.$route.params.id),
                oldData: inputOld,
                newData: input,
              },
            },
          })
          .then((response) => {
            if (response.data.updateVehicle.isSuccessful) {
              this.$toast.success(`Data berhasil diubah`)
              this.$router.push({ name: 'Master Fleet' })
            } else {
              this.$toast.error(response.data.updateVehicle.message)
            }
          })
      }
    },

    disabledAfterToday(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },

    clearSelect(param) {
      if (param == 'firstDriver') {
        if (this.form[param].isDriver) {
          var myIndex = this.drivers.drivers.data
            .map((item) => item.userId)
            .indexOf(this.form[param].userId)
          if (myIndex < 0) {
            this.drivers.drivers.data.push(this.form[param])
          }
        }
      } else if (param == 'device') {
        var deviceIndex = this.devices.devices
          .map((item) => item.imei)
          .indexOf(this.form[param].imei)
        if (deviceIndex < 0) {
          this.devices.devices.push(this.form[param])
        }
      }
      if (this.form[param] != null) {
        this.form[param] = null
      }
    },
    just_number(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.key;
      if (charCode == 101 || charCode == 46 || charCode == 45 ) {
        evt.preventDefault()
      } else {
        return true;
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            variant="outline-primary"
            class="ms-2"
            @click="$router.push({ name: 'Master Fleet Update History' })"
          >
            <i class="mc-fa icon-large icon-outline_file-text"></i>{{ $t('global.historyUpdate') }}
          </b-button>

          <b-button @click="toCancel" variant="outline-primary" class="mx-2">
            <i class="mc-fa icon-fill_close"></i> {{ $t('global.cancel') }}
          </b-button>

          <b-button variant="primary" type="button" @click="handleOk()">
            <i class="mc-fa icon-outline_save"></i> {{ this.$t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>

    <form ref="form" @submit.stop.prevent="handleSubmit" class="mc-form">
      <h4 class="card-title">{{ $t('master.form.fleet.fleetInformation') }}</h4>
      <b-card>
        <b-row>
          <b-col sm="12" md="3">
            <b-form-group
              id="licensePlate_plate"
              :label="$t('master.form.fleet.licensePlate')"
              label-for="licensePlate"
              label-class="required"
            >
              <b-form-input
                id="licensePlate"
                :placeholder="$t('master.form.fleet.licensePlate')"
                v-model.trim="$v.form.licensePlate.$model"
                trim
                :class="{
                  'is-invalid': $v.form.licensePlate.$error,
                }"
                v-on:keypress="isAlphabetNumberOnly($event)"
                onkeyup="this.value = this.value.toUpperCase();"
              ></b-form-input>
              <div v-if="$v.form.licensePlate.$error" class="invalid-feedback">
                <span v-if="!$v.form.licensePlate.required">
                  {{ $t('master.form.fleet.licensePlate') }}
                  {{ $t('global.validation.required') }}
                </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3">
            <b-form-group
              id="model_label"
              :label="`${$t('master.form.fleet.fleetBrandType')}`"
              label-for="model"
              label-class="required"
            >
              <multiselect
                v-model="form.model"
                :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.fleetBrandType')}`"
                :options="vehicleModels.vehicleModels"
                label="model"
                :class="{
                  'is-invalid': $v.form.model.$error,
                }"
                @input="chooseVehType"
              >
              </multiselect>
              <div v-if="$v.form.model.$error" class="invalid-feedback">
                <span v-if="!$v.form.model.required"> Manufaktur Wajib Terisi </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3">
            <b-form-group
              id="fleetType_label"
              :label="`${$t('master.form.fleet.fleetType')}`"
              label-for="fleetType"
              label-class="required"
            >
              <multiselect
                v-model="$v.form.fleetType.$model"
                :options="vehTypeOptions"
                group-values="libs"
                group-label="parent"
                track-by="type"
                label="type"
                :placeholder="`${$t('global.form.select')} ${$t('Jenis Kendaraan')}`"
                :class="{
                  'is-invalid': $v.form.fleetType.$error,
                }"
                ><span slot="noResult"
                >Oops! No elements found. Consider changing the search query.</span
                ></multiselect
              >
              <div v-if="$v.form.fleetType.$error" class="invalid-feedback">
                <span v-if="!$v.form.fleetType.required"> Jenis Kendaraan Wajib Terisi </span>
              </div>
            </b-form-group>
          </b-col>
          <!-- <b-col sm="12" md="3">
            <b-form-group id="driver1Id_label" :label="$t('master.form.fleet.firstDriver')" label-for="driver1Id">
              <multiselect
                v-model="form.firstDriver"
                :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.firstDriver')}`"
                :options="firstDriverOptions"
                label="fullname"
              >
                <template slot="clear" v-if="form.firstDriver != null">
                  <span class="multiselect-clear" @click="clearSelect('firstDriver')">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1024 1024"
                      width="1em"
                      height="1em"
                    >
                      <path
                        d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"
                      ></path>
                    </svg>
                  </span>
                </template>
              </multiselect>
            </b-form-group>
          </b-col> -->
          <b-col sm="12" md="3">
            <b-form-group id="driver1Id_label" :label="$t('master.form.fleet.firstDriver')" label-for="driver1Id">
                <input 
                    v-model="form.firstDriver.fullname"
                    :placeholder="`${$t('master.form.fleet.firstDriver')}`"
                    disabled
                    class="form-control"
                />
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3">
            <div class="mt-3">
              <b-form-group id="hullNo_label" :label="$t('master.form.fleet.hullNumber')" label-for="hullNo">
                <b-form-input
                  id="hullNo"
                  :placeholder="`${$t('global.form.enter')} ${$t('master.form.fleet.hullNumber')}`"
                  v-model="form.hullNo"
                ></b-form-input>
              </b-form-group>
            </div>
          </b-col>
          <b-col sm="12" md="3">
            <div class="mt-3">
              <b-form-group
                id="ownership_label"
                :label="$t('master.form.fleet.ownership')"
                label-for="ownership"
                label-class="required"
              >
                <multiselect
                  v-model="form.ownership"
                  :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.ownership')}`"
                  :options="vehicleOwnerships"
                  label="label"
                  :class="{
                    'is-invalid': $v.form.ownership.$error,
                  }"
                >
                </multiselect>
                <div v-if="$v.form.ownership.$error" class="invalid-feedback">
                  <span v-if="!$v.form.ownership.required"> Ownership must be included </span>
                </div>
              </b-form-group>
            </div>
          </b-col>

          <b-col sm="12">
            <div class="mt-3">
              <div class="form-check-right form-switch">
                <input
                  class="form-check-input ms-2"
                  type="checkbox"
                  id="SwitchCheckSizemd"
                  v-b-toggle.accordion-3
                />
                <label class="" for="SwitchCheckSizemd"> {{ $t('master.form.driver.detailInfo.text') }} </label>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-row v-if="form.fleetType">
            <b-col sm="12" md="3">
              <div class="my-3">
                <b-form-group :label="$t('master.form.fleet.tonase')">
                  {{ form.fleetType.tonnage ? form.fleetType.tonnage : 0 }}
                </b-form-group>
              </div>
            </b-col>

            <b-col sm="12" md="3">
              <div class="my-3">
                <b-form-group :label="$t('master.form.fleet.volume')">
                  {{ form.fleetType.volume ? form.fleetType.volume : 0 }}
                </b-form-group>
              </div>
            </b-col>

            <b-col sm="12" md="3">
              <div class="my-3">
                <b-form-group :label="$t('master.form.fleet.fuel.title')">
                  <span v-if="form.fleetType.fuelType === 'D'"> {{ $t('master.form.fleet.fuel.diesel') }} </span>
                  <span v-else-if="form.fleetType.fuelType === 'G'"> {{ $t('master.form.fleet.fuel.gasoline') }} </span>
                  <span v-else-if="form.fleetType.fuelType === 'E'"> {{ $t('master.form.fleet.fuel.electronic') }} </span>
                  <span v-else-if="form.fleetType.fuelType === 'H'"> {{ $t('master.form.fleet.fuel.hybrid') }} </span> 
                  <span v-else-if="form.fleetType.fuelType === 'C'"> {{ $t('master.form.fleet.fuel.hidrogen') }} </span>
                  <span v-else> - </span>
                </b-form-group>
              </div>
            </b-col>

            <b-col sm="12" md="2">
              <div class="my-3">
                <b-form-group :label="$t('master.form.fleet.transmission.title')">
                  <span v-if="form.fleetType.transmissionType === 'A'">{{ $t('master.form.fleet.transmission.auto') }}</span>
                  <span v-if="form.fleetType.transmissionType === 'M'">{{ $t('master.form.fleet.transmission.manual') }}</span>
                  <span v-if="form.fleetType.transmissionType === 'T'">{{ $t('master.form.fleet.transmission.triptonic') }}</span>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="3">
              <b-form-group id="status_label" :label="$t('master.form.fleet.status.title')" label-for="status">
                <multiselect
                  v-model="form.status"
                  :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.status.title')}`"
                  :options="statusOptions"
                  label="label"
                >
                </multiselect>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <b-form-group id="odometer_label" label="Odometer (Km)" label-for="odometer">
                  <b-form-input
                    id="odometer"
                    v-model="form.odometer"
                    min="0"
                    :class="{
                      'is-invalid': $v.form.odometer.$error,
                    }"
                    :placeholder="`${$t('global.form.enter')} Odometer (Km)`"
                    type="text"
                  >
                  </b-form-input>
                  <div v-if="$v.form.odometer.$error" class="invalid-feedback">
                    <span v-if="!$v.form.odometer.required">
                      Odometer tidak bisa lebih kecil dari 0 (nol)
                    </span>
                  </div>
                </b-form-group>
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <b-form-group
                  id="thermoType_label"
                  :label="$t('master.form.fleet.thermoType')"
                  label-for="thermoType"
                >
                  <multiselect
                    v-model="form.thermoType"
                    :placeholder="`${$t('global.form.select')} ${$t(
                      'master.form.fleet.thermoType'
                    )}`"
                    :options="thermoTypes.thermoTypes"
                    label="text"
                    value="text"
                  >
                  </multiselect>
                </b-form-group>
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <b-form-group id="boxType_label" :label="$t('master.form.fleet.boxType')" label-for="boxType">
                  <multiselect
                    v-model="form.boxType"
                    :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.boxType')}`"
                    :options="boxTypes.boxTypes"
                    label="text"
                  >
                  </multiselect>
                </b-form-group>
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <b-form-group id="chassisNo_label" :label="$t('master.form.fleet.chassisNumber')" label-for="chassisNo">
                  <b-form-input
                    id="chassisNo"
                    :placeholder="`${$t('global.form.enter')} ${$t('master.form.fleet.chassisNumber')}`"
                    v-model="form.chassisNumber"
                    trim
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <b-form-group
                  id="machineNo_label"
                  :label="`${$t('master.form.fleet.engineNumber')}`"
                  label-for="machineNo"
                >
                  <b-form-input
                    id="machineNo"
                    :placeholder="`${$t('global.form.enter')} ${$t(
                      'master.form.fleet.engineNumber'
                    )}`"
                    v-model="form.machineNumber"
                    trim
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <b-form-group id="year_label" :label="`${$t('master.form.fleet.fleetAge')}`" label-for="year">
                  <date-picker
                    v-model="form.year"
                    :format="yearShow"
                    value-type="YYYY"
                    :placeholder="`${$t('global.form.enter')} ${$t('master.form.fleet.fleetAge')}`"
                    :first-day-of-week="1"
                    lang="en"
                    type="year"
                    confirm
                    :disabled-date="disabledAfterToday"
                  ></date-picker>
                </b-form-group>
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <b-form-group
                  id="carrosserie_label"
                  :label="$t('master.form.fleet.karoseri')"
                  label-for="carrosserie"
                >
                  <b-form-input
                    id="carrosserie"
                    v-model="form.carrosserie"
                    :placeholder="`${$t('global.form.enter')} ${$t('master.form.fleet.karoseri')}`"
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <b-form-group
                  id="fuelEfficiency_label"
                  :label="$t('master.form.fleet.fuel.efficiency')"
                  label-for="fuelEfficiency"
                >
                  <b-form-input
                    id="fuelEfficiency"
                    v-model="form.fuelEfficiency"
                    :placeholder="`${$t('global.form.enter')} ${$t('master.form.fleet.fuel.efficiency')}`"
                    type="number"
                    @keypress="isNumber($event)"
                    @paste="isPasteNumber($event)"
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <b-form-group id="pool_label" :label="$t('master.form.fleet.pool')" label-for="garageId">
                  <multiselect
                    v-model="form.geofence"
                    :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.pool')}`"
                    :options="geofences.geofences.data"
                    label="fenceName"
                  >
                  </multiselect>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
        </b-collapse>
      </b-card>

      <h4 class="card-title">{{ $t('master.pelacak') }}</h4>
      <b-card>
        <b-row>
          <b-col>
            <b-form-group id="deviceCode_label" :label="$t('master.form.tracker.trackerId')" label-for="deviceCode">
              <multiselect
                v-model="form.device"
                :placeholder="`${$t('global.form.select')} ${$t('master.form.tracker.trackerId')}`"
                :options="devices.devices"
                label="identifier"
              >
                <template slot="clear" v-if="form.device != null">
                  <span class="multiselect-clear" @click="clearSelect('device')">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1024 1024"
                      width="1em"
                      height="1em"
                    >
                      <path
                        d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"
                      ></path>
                    </svg>
                  </span>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="vendor_label" :label="$t('master.form.tracker.vendor')" label-for="vendor">
              {{ form.device ? form.device.vendorType : '-' }}
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="deviceType_label" :label="$t('master.form.tracker.deviceType')" label-for="deviceType">
              {{ form.device ? form.device.deviceName : '-' }}
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="imei_label" :label="$t('master.form.tracker.imei')" label-for="imei">
              {{ form.device ? form.device.imei : '-' }}
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="phoneNo_label" :label="$t('master.form.tracker.phoneNo')" label-for="phoneNo">
              {{ form.device ? form.device.phoneNo : '-' }}
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <div class="clearfix mb-3">
        <div class="float-start">
          <h4 class="card-title">{{ $t('master.form.fleet.documentPermit.text') }}</h4>
        </div>

        <div class="float-end">
          <b-button v-if="selected.length" @click="toDelete" variant="outline-danger" class="mx-2">
            <i class="mc-fa icon-outline_trash"></i> {{ $t('global.delete') }}
          </b-button>
          <b-button variant="primary" @click="addDocumentPermit">
            <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
          </b-button>
        </div>
      </div>

      <b-card>
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :fields="fields"
            :items="tData"
            responsive="sm"
            class="datatables mc-table-fleetdoc"
          >
            <template #head(check)>
              <div class="form-check">
                <b-form-checkbox
                  v-model="allSelected"
                  :indeterminate="indeterminate"
                  @change="toggleAll"
                >
                </b-form-checkbox>
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <b-form-checkbox
                  @change="checkTable($event, data)"
                  v-model="selectedModel[data.index]"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(type)="data">
              <multiselect
                v-model="tData[data.index].docType"
                :placeholder="`${$t('global.form.select')} ${$t('master.form.fleet.documentPermit.text')}`"
                :options="docTypeUnSelected"
                openDirection="top"
                :class="{
                  'is-invalid': $v.tData.$each[data.index].docType.$error,
                }"
              >
              </multiselect>
              <div v-if="$v.tData.$each[data.index].docType.$error" class="invalid-feedback">
                <span v-if="!$v.tData.$each[data.index].docType.required">
                  Nama Dokumen Wajib Terisi
                </span>
              </div>
            </template>

            <template #cell(number)="data">
              <b-form-input
                :placeholder="`${$t('global.form.enter')} ${$t('master.form.fleet.documentPermit.number')} ${$t('master.form.fleet.documentPermit.text')}`"
                v-model="tData[data.index].docNumber"
                trim
              ></b-form-input>
            </template>

            <template #cell(expired)="data">
              <date-picker
                format="DD MMM YYYY"
                value-type="YYYY-MM-DD"
                :placeholder="`${$t('global.form.enter')} ${$t('master.form.fleet.documentPermit.text')} ${$t('master.form.fleet.documentPermit.expired')}`"
                v-model="tData[data.index].validUntil"
                @input="checkStatus(data.index)"
              ></date-picker>
            </template>

            <template #cell(status)="data">
              <div>
                <span
                  v-if="tData[data.index].status === 'expired'"
                  class="mc-status mc-status--red"
                  >{{ $t('master.form.fleet.documentPermit.expired') }}</span
                >
                <span
                  v-else-if="tData[data.index].status === 'near'"
                  class="mc-status mc-status--yellow"
                  >{{ $t('master.form.fleet.documentPermit.status.nearExpired') }}</span
                >
                <span
                  v-else-if="tData[data.index].status === 'active'"
                  class="mc-status mc-status--green"
                  >{{ $t('master.form.fleet.documentPermit.status.active') }}</span
                >
              </div>
            </template>
          </b-table>
        </div>
      </b-card>
    </form>
  </Layout>
</template>
